/**
 * "An AI answer is arriving in a text box of this screen."
 *
 * The box itself says so with `data-ai-busy` (TextEditor). Things OUTSIDE the
 * box need to know it, and need a way to stop it, without holding on to the
 * box: the Undo/Redo arrows and Ctrl/Cmd+Z. While an answer arrives, their
 * first press only stops the answer; it does not also take a step back
 * (review round 8: one press did both, and the notice then said "Your text
 * was not changed" over a text the undo had just changed).
 */
export const STOP_AI_ANSWER = 'sympl:stop-ai-answer';
/** Sent whenever a box starts or stops having an answer arrive. */
export const AI_BUSY_CHANGED = 'sympl:ai-busy-changed';

export const anAnswerIsArriving = (): boolean =>
  typeof document !== 'undefined' && !!document.querySelector('[data-ai-busy]');

/** Asks whichever box has an answer arriving to close, which stops it. */
export const stopTheArrivingAnswer = (): void => {
  window.dispatchEvent(new CustomEvent(STOP_AI_ANSWER));
};
